import { Spinner } from '@/ui/spinner/spinner';
import { useCruise } from '../../hooks/use-cruise';
import { useDay } from '../../hooks/use-day';
import { DayList } from '../day-list/day-list';
import classes from './itinerary-overview.module.css';

/**
 * @returns {React.JSX.Element}
 */
export function ItineraryOverview() {
  const { getCurrentDayNumber } = useDay();
  const { data: cruise, isLoading, isError } = useCruise();

  return (
    <div className={classes.itineraryOverview} style={{ display: getCurrentDayNumber() ? 'none' : undefined }}>
      {isLoading ? (
        <div className={classes.container}>
          Loading itinerary
          <div className={classes.spinner}>
            <Spinner />
          </div>
        </div>
      ) : isError ? (
        <div className={classes.container}>Itinerary unavailable at this time, please try again later</div>
      ) : (
        <>
          <h1 className={classes.title}>{cruise?.name}</h1>
          <p className={classes.description}>
            For detailed information about each port of call and the excursions we offer, both included and optional,
            please click on the individual points on the map.
          </p>
          <DayList />
        </>
      )}
    </div>
  );
}
